
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_1e9bf_189",
  "refresh": "awsui_refresh_1r9lg_1e9bf_189",
  "animating": "awsui_animating_1r9lg_1e9bf_203",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_1e9bf_226",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_1e9bf_230",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_1e9bf_233",
  "preference-icon--border": "awsui_preference-icon--border_1r9lg_1e9bf_236",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_1e9bf_240",
  "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_1e9bf_243",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_1e9bf_246",
  "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_1e9bf_249",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_1e9bf_252",
  "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_1r9lg_1e9bf_256",
  "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_1r9lg_1e9bf_259",
  "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_1r9lg_1e9bf_262",
  "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_1r9lg_1e9bf_265",
  "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_1r9lg_1e9bf_268",
  "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_1r9lg_1e9bf_271",
  "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_1r9lg_1e9bf_275",
  "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_1r9lg_1e9bf_278",
  "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_1r9lg_1e9bf_281",
  "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_1r9lg_1e9bf_284",
  "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_1r9lg_1e9bf_287",
  "root": "awsui_root_1r9lg_1e9bf_291",
  "preferences-button": "awsui_preferences-button_1r9lg_1e9bf_304",
  "close-button": "awsui_close-button_1r9lg_1e9bf_308",
  "drawer-closed": "awsui_drawer-closed_1r9lg_1e9bf_319",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_1e9bf_324",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_1e9bf_344",
  "position-bottom": "awsui_position-bottom_1r9lg_1e9bf_353",
  "position-side": "awsui_position-side_1r9lg_1e9bf_380",
  "slider": "awsui_slider_1r9lg_1e9bf_386",
  "slider-side": "awsui_slider-side_1r9lg_1e9bf_415",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_1e9bf_420",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_1e9bf_431",
  "open-button": "awsui_open-button_1r9lg_1e9bf_442",
  "open-button-side": "awsui_open-button-side_1r9lg_1e9bf_446",
  "slider-icon": "awsui_slider-icon_1r9lg_1e9bf_453",
  "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_1e9bf_459",
  "slider-icon-side": "awsui_slider-icon-side_1r9lg_1e9bf_462",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_1e9bf_466",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_1e9bf_476",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_1e9bf_479",
  "content-bottom": "awsui_content-bottom_1r9lg_1e9bf_487",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_1e9bf_500",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_1e9bf_505",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_1e9bf_509",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_1e9bf_513",
  "content-side": "awsui_content-side_1r9lg_1e9bf_518",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_1e9bf_529",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_1e9bf_532",
  "header": "awsui_header_1r9lg_1e9bf_537",
  "header-text": "awsui_header-text_1r9lg_1e9bf_546",
  "header-divider": "awsui_header-divider_1r9lg_1e9bf_556",
  "header-actions": "awsui_header-actions_1r9lg_1e9bf_562",
  "divider": "awsui_divider_1r9lg_1e9bf_570"
};
  